<div class="n-oldalfej">
  <h2>E-mail elkapó</h2>
  <span class="n-alcim">Számlák e-mailben – a mellékletek a Dokumentumtárba kerülnek</span>
</div>

<div class="n-panel" *ngIf="aktiv.ugyfelId">
  <div class="n-panel-cim">{{ aktiv.ugyfelNev }} címe</div>
  <div class="ee-cim">
    <ion-icon name="mail-outline"></ion-icon>
    <b>{{ cim || ('&lt;adószám&gt;@' + domain) }}</b>
    <button type="button" class="ov-gomb" (click)="masol()" [disabled]="!cim"><ion-icon name="copy-outline"></ion-icon>Másolás</button>
  </div>
  <p class="halvany ee-sugo">Erre a címre küldött (vagy továbbított) levelek PDF-mellékletei az ügyfél Dokumentumtárába kerülnek, és ott a könyvelési tételekhez párosíthatók.</p>
</div>

<div class="n-panel" *ngIf="aktiv.ugyfelId">
  <div class="n-panel-cim" style="display:flex;align-items:center;gap:10px">
    <span>Beérkezett levelek ({{ emailek.length }})</span>
    <span class="spacer" style="flex:1"></span>
    <button type="button" class="ov-gomb" (click)="betolt()" [disabled]="betoltes" title="Beérkezett levelek frissítése">
      <ion-icon name="refresh-outline"></ion-icon> Frissítés
    </button>
  </div>
  <div class="tabla-wrap ee-lista" *ngIf="emailek.length">
    <table class="n-racs">
      <thead><tr><th>Érkezett</th><th>Feladó</th><th>Tárgy</th><th>Címzett</th><th class="num">Mellékl.</th><th>Állapot</th></tr></thead>
      <tbody>
        <tr *ngFor="let e of emailek">
          <td>{{ e.erkezett }}</td><td>{{ e.felado }}</td><td class="n-ket-sor">{{ e.targy }}</td><td>{{ e.cimzett }}</td>
          <td class="num">{{ e.mellekletek }}</td>
          <td><span class="ee-allapot" [attr.data-a]="e.statusz">{{ e.statusz }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="halvany" *ngIf="!emailek.length && !betoltes">Még nem érkezett e-mail ehhez az ügyfélhez.</div>
</div>

<div class="n-panel" *ngIf="beall">
  <div class="n-panel-cim">Központi elosztó – a teljes installációra, egyszer</div>
  <div class="ee-racs">
    <label class="kv-mezo"><span>Elosztó URL</span><input type="text" [(ngModel)]="beall.email_dispatcher_url" placeholder="https://naplo-email-dispatcher…workers.dev"></label>
    <label class="kv-mezo"><span>Saját webhook</span><input type="text" [(ngModel)]="beall.email_self_url" placeholder="https://<saját-host>/api/naplo/email/bejovo"></label>
    <label class="kv-mezo"><span>Domain</span><input type="text" [(ngModel)]="beall.email_domain"></label>
    <label class="kv-mezo"><span>Közös titok</span><input type="password" [(ngModel)]="beall.email_shared_secret" [placeholder]="beall.hasSecret ? '•••• (mentve)' : ''"></label>
    <label class="kv-mezo"><span>API-kulcs</span><input type="password" [(ngModel)]="beall.email_api_key" [placeholder]="beall.hasApiKey ? '•••• (mentve)' : ''" title="REGISTRY_KEY"></label>
  </div>
  <div class="ee-lab">
    <button type="button" class="ov-gomb fo" (click)="ment()"><ion-icon name="save-outline"></ion-icon>Mentés</button>
    <button type="button" class="ov-gomb" [disabled]="regFut" (click)="regisztracio()"><ion-icon name="cloud-upload-outline"></ion-icon>{{ regFut ? 'Regisztráció…' : 'Regisztráció a központhoz' }}</button>
  </div>
</div>
